export default __webpack_public_path__ + "d76de6305be15d576ddf5524b5c5a21f.jpg";